import { createContext } from 'react'
import { DataSourceResolver } from '@halo/components/data-table-view/types'

interface IDataTableContext {
    instanceId?: string
    loading?: boolean
    currentDataSource: any[] | undefined
    resolveDataSource: DataSourceResolver<any>
}

export const DataTableContext = createContext<IDataTableContext>({
    loading: true,
} as any)
